import React from "react";
import PropTypes from "prop-types";
import branch from "branch-sdk";
import NotificationDownloadCard from "./widgets/NotificationDownloadCard";
import { injectIntl } from "react-intl";
import { showToast } from "actions/toastActions";
import { connect } from "react-redux";
import messages from "components/messagesDescription";

class NotificationDownloadContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { phone: "" };

    this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
  }

  updatePhoneNumber = phone => {
    // added a check to prevent displaying "+ only" on initial load.
    // this is a current issue on the plugin
    if (phone !== "+") {
      this.setState({ phone: phone });
    }
  };

  sendSms = () => {
    const { phone } = this.state;
    const { showToast, intl } = this.props;
    const smsFailedMessage = intl.formatMessage(messages.dashboard.downloadApp.smsFailed);
    const smsSuccessMessage = intl.formatMessage(messages.dashboard.downloadApp.smsSuccess);

    const linkData = {
      tags: [],
      channel: "Website",
      feature: "TextMeTheApp",
      data: {
        foo: "bar",
      },
    };
    const options = {};
    const smsCallback = function(err, result) {
      if (err) {
        showToast({ message: smsFailedMessage });
      } else {
        showToast({ message: smsSuccessMessage });
      }

      branch.logout();
    };

    const sendSMSRequest = err => {
      if (err) {
        showToast({ message: smsFailedMessage });
      } else {
        branch.sendSMS(phone, linkData, options, smsCallback);
      }
    };

    // Initialize branch io
    // TODO: Needs to implement temporary token instead of hard-coding the actual key (APL-3250)
    branch.init("key_live_lfdOK3xtedKqYRXzT5ocubcoADcDFZYD", sendSMSRequest);
  };

  render() {
    const { notifications = [] } = this.props;

    if (notifications.length) {
      return (
        <NotificationDownloadCard
          notifications={notifications}
          sendSms={this.sendSms}
          updatePhoneNumber={this.updatePhoneNumber}
        />
      );
    }

    return null;
  }
}

NotificationDownloadContainer.propTypes = {
  notifications: PropTypes.array,
  showToast: PropTypes.func,
  intl: PropTypes.object,
};

const mapDispatchToProps = {
  showToast,
};

export default injectIntl(
  connect(
    null,
    mapDispatchToProps
  )(NotificationDownloadContainer)
);



// WEBPACK FOOTER //
// ./components/dashboard/NotificationDownloadContainer.js